(function () {
    'use strict';

    angular
        .module('tyallsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app.account.finishReset', {
            // parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                '@app': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
